import { getCssVariable } from "src/utils/utils";
import Layout from "../Layout/Layout";
import { client } from "src/utils/api";
import { useEffect, useState } from "react";
import PartnerHero from "./components/PartnerHero";
import PartnerTablist from "./components/PartnerTablist";
import PartnerCard from "./components/PartnerCard";
import PartnerImageAndList from "./components/PartnerImageAndList";
import { useNavigate } from "react-router-dom";
import { MarqueeComponent } from "../Home/components";


const PartnerShip = () => {
   const primaryColor = getCssVariable("--primary-color");
   const gqlClient = client;
   const [productPageData, setProductPageData] = useState<any[]>([]);
   const [loading, setLoading] = useState(true);
   const [seoData, setSeoData] = useState<any>();
   const navigate=useNavigate()
 
   useEffect(() => {
     const fetchProductPageData = async () => {
       try {
         setLoading(true);
 
         const productResponse = await gqlClient.GetPagePartnerBySlug({
           slug: "partner-page",
         });
 
 
         const productId =
           productResponse?.pageGenericCollection?.items[0]?.sys.id;
 
         if (!productId) {
          navigate('/not-found', { replace: true });
          return;
         }
         const [responseOne] = await Promise.all([
           gqlClient.GetPartnerPageOne({ id: productId }),
         ]);
 
         const componentsOne =
           responseOne?.pageGeneric?.componentsCollection?.items || [];

         const cleanedData = [...componentsOne].filter(
           (item) => item && item.sys?.id && Object.keys(item).length > 2
         );
         setProductPageData(cleanedData)
       
         setLoading(false);
       } catch (error) {
         console.error("Error fetching Product data:", error);
         setLoading(false);
       }
     };
 
     fetchProductPageData();
   }, []);

   useEffect(()=>{
    if(productPageData){
      const seoComponent =
    productPageData?.find(
      (item: any) => item.__typename === "SeoFields"
    );
  if (seoComponent) setSeoData(seoComponent);
     }
  },[productPageData])


   const renderComponent = (component: any) => {
    const componentMap = {
      Hero: PartnerHero,
      TabList: {
        'TabList':PartnerTablist
      },
      ImageAndTextList:  PartnerImageAndList,
      Accordion: {
        'Card': PartnerCard,
      },
      LogoList: {
        LogoList: (props) => <div className="batch-marquee"><MarqueeComponent {...props} batch={true}/> </div>,
      },
    };
    const contentTypeId = component.__typename;
    const variant = component.variant;

    // Handle ImageAndText with variant
    if (
      contentTypeId === "Accordion"  || contentTypeId === "TabList"  || contentTypeId === "LogoList"
    ) {
      const Component = componentMap[contentTypeId]?.[variant];
      if (Component) {
        return Component ? (
          <Component key={component.sys.id} content={component} />
        ) : null;
      }
      console.warn(
        `Unmapped variant: ${variant} for contentTypeId: ${contentTypeId}`
      );
    } else {
      // Handle all other components
      const Component = componentMap[contentTypeId];
      if (Component) {
        return Component ? (
          <Component key={component.sys.id} content={component} />
        ) : null;
      }
    }
  };

  if (loading) {
    return <Layout loading={loading} />;
  }
 

  return (
  
    <Layout
    style={{ color: "#fff" }}
    hamburgerStyle={{ backgroundColor: primaryColor }}
    saleClassName="btn-gradient-bdr"
    headerStyle={{ position: "relative" }}
    seoData={seoData}
  >
    <div className="partners-page">
      {productPageData?.map((component) => renderComponent(component))}
    </div>
  </Layout>
  );
};

export default PartnerShip;
